import { useTranslation } from "react-i18next";
import { css } from "../../../../../../styled-system/css";
import { ALGORITHM_OPTIONS, type AlgorithmValue } from "../constants";

const ALGORITHM_DESCRIPTION_KEYS = {
  [ALGORITHM_OPTIONS.PRODUCT_LAUNCH.value]: "Best for new campaigns or products with little to no performance history.",
  [ALGORITHM_OPTIONS.GROWTH_MAX.value]:
    "Analyzes historical data to maximize long-term profit for each target.\n\nBest for established campaigns where stable, consistent growth is the priority.",
  [ALGORITHM_OPTIONS.ROAS_BOOST.value]:
    "Reacts quickly to recent performance trends, scaling up bids aggressively on high-converting keywords and pulling back on underperformers.",
  [ALGORITHM_OPTIONS.RULES_ENGINE_ONLY.value]:
    "Create fully custom bidding rules tailored to your specific goals, triggers, and conditions.",
  [ALGORITHM_OPTIONS.PLACEMENT_MAX.value]:
    "Optimizes bids independently for each Amazon ad placement (Top of Search, Product Pages, etc.).\n\nBest for mature campaigns with enough placement-level data and strong performance variance across placements.",
  [ALGORITHM_OPTIONS.SMART_SPEND.value]:
    "Solves a global optimization across all targets in your campaign to maximize total sales within your daily budget.",
} as const satisfies Record<AlgorithmValue, string>;

export const AlgoDescription = ({ algorithm }: { algorithm: AlgorithmValue }) => {
  const { t } = useTranslation(["advertising"]);
  const descriptionKey = ALGORITHM_DESCRIPTION_KEYS[algorithm];
  return (
    <p className={css({ color: "gray", fontSize: "13px", fontWeight: 500, whiteSpace: "pre-line" })}>
      {t(($) => $.advertising.algorithmDescriptions[descriptionKey])}
    </p>
  );
};
